import es_GT_default from "./es_GT.js";
import { LanguageCode } from "@vana/core";
//#region src/translations/translations.ts
var translations = { [LanguageCode.ES_GT]: { ...es_GT_default } };
//#endregion
export { translations };

//# sourceMappingURL=translations.js.map